import React from "react";
import { isVtiBOP } from "../../common/JourneyType";
import SignatureSuccessPageHEYCAR from './SignatureSuccessPageHEYCAR';
import SignatureSuccessPageVTIGIS from './SignatureSuccessPageVTIGIS';
const SignatureSuccessPage = ({ shoppingCart, redirectUrl, prefill }) => {

  const originSystem = prefill?.salesChannel?.originSystem;

  return (
    <>
      {isVtiBOP(originSystem)
        ?
          (
            <SignatureSuccessPageVTIGIS
              shoppingCart={shoppingCart}
              prefill={prefill}
            />
          )
        :
          (
            <SignatureSuccessPageHEYCAR
              shoppingCart={shoppingCart}
              redirectUrl={redirectUrl}
              prefill={prefill}
            />
          )
      }
    </>
  );
};

export default SignatureSuccessPage;
